/**
 * https://www.framer.com/motion/gestures/
 * @param hover
 * @param tap
 */
export const varHover = (hover = 1.09, tap = 0.97) => ({
	hover: { scale: hover },
	tap: { scale: tap },
});
